import axios from "axios";
import DriversType from "../../../types/DriversType";
import { ServerSideTypes } from "../../common/OperationCommonTypes";
import { Driver } from "../../vehicle-exit/VehicleExitStatus";
import { DriversTypes } from "../Types";

const DriversServer ={
    get:{

        getAllDrivers:(tenant:string,data:any,serverParams: ServerSideTypes.IParams)=>{
         return axios.get<ServerSideTypes.IResult<DriversTypes.Drivers>>("./masterdatatransportation/driver",{params:{tenant,...data,...serverParams}}).then(
            response => response.data,
            )
          },
          export:(tenant:string,data:any)=>{
            return axios.get("./masterdatatransportation/driver/excel",{params:{tenant,...data},responseType:"arraybuffer"});
          }
        },
   
      delete:{
        deleteDrivers:(id: number, tenant:string)=>{
          return  axios.delete(`/masterdatatransportation/driver/${id}`,{ params:{ tenant:tenant}}).then(response => response.data);
          }
    },
    put:{
     updateDriver:(id:number,tenant:string,driver:DriversTypes.Drivers) =>{
       return axios.put(`/masterdatatransportation/driver/${id}`,driver,{params:{tenant:tenant}}).then(response => response.data);
     },
    
    },
    create:{
      createDriver:(tenant:string,driver:DriversTypes.Drivers)=>{
          return axios.post("./masterdatatransportation/driver",driver,{params:{tenant:tenant}})
      }
     }
    }

export default DriversServer;